import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Maison Vaurel',
    description: 'Maison Vaurel, Paris since 1948. Ready-to-wear, leather goods, jewelry and fragrance made by hand, with private appointments and reservations in boutique.',
    url: getOrigin(),
    ogImage: 'https://maison-vaurel.cdn.modulify.website/brand/og-image.jpg'
}

export const maisonLinks = [
    { label: 'The Maison', href: '/maison' },
    { label: 'Boutiques', href: '/boutiques' }
]

export const clientServices = {
    phone: '+33 1 99 00 10 48',
    hours: 'Monday to Saturday, 10am to 7pm, Paris time'
}

export const appointmentServices = [
    'Ready-to-wear styling',
    'Leather goods',
    'Jewelry',
    'Fragrance consultation',
    'Made-to-measure'
]

export const appointmentTimes = ['Morning', 'Afternoon', 'Evening']

export const BAG_STORAGE_KEY = 'vaurel-bag'

export const MAX_ITEM_QUANTITY = 5
